<template>
  <div id="app">
    <component :is="template"/>
  </div>
</template>

<script>

export default {
  computed: {
    template () {
      return this.$route.meta.template
    }
  }
}
</script>
